import BaseIcon from "./BaseIcon";
import React, { ReactElement, SVGProps } from "react";

export default function Disc(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <circle cx="2" cy="2" r="2" fill="#475480"/>
    </BaseIcon>
  );
}
